/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>交易订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.userkey" placeholder="输入姓名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.transId" placeholder="输入交易单号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.payStatus" placeholder="请选择支付状态">
          <el-option v-for="type in payStatus" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.item_no" placeholder="请选择项目类型">
         <el-option value=""  key="请选择项目"></el-option>

          <el-option v-for="type in item" :label="type.item_name" :value="type.item_no" :key="type.item_no"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
          <el-date-picker
            v-model="formInline.date"
            value-format="timestamp"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="formReset()">重置</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column align="center" prop="realname" label="姓名" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="identitycard_no" label="身份证号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="sex" label="性别" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="age" label="年龄（周岁）" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="tel" label="手机号" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="prescription_name" align="center" label="预约项目" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="address" align="center" label="地址" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="bl_img" align="center" label="病历资料" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="ylt" v-for="il in scope.row.img_list">
              <img :src="il" @click="yulandatu(il)">
            </div>

           </template>

      </el-table-column>
      <el-table-column sortable prop="yysj" align="center" label="预约时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="pay_status"  align="center" label="支付状态" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-show="scope.row.pay_status == 'SUCCESS'"><span style="color: green;">支付成功</span></div>
          <div v-show="scope.row.pay_status == 'SUCCESSBUTHISERROR'"><span style="color: red;">单边账</span></div>
          <div v-show="scope.row.pay_status == 'REFUND'"><span style="color: gray;">已退费</span></div>
          <div v-show="scope.row.pay_status == 'NOTPAY'"><span style="color: red;">未支付</span></div>

         </template>
      </el-table-column>

      <el-table-column sortable prop="pay_amount" align="center" label="支付金额（元）" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="pay_time" align="center" label="支付时间" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="order_status" align="center" label="订单状态" width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-show="scope.row.order_status == '1'"><span style="color: green;">已确认</span></div>
            <div v-show="scope.row.order_status == '0'"><span style="color: red;">待确认</span></div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="beizhu" label="备注" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="160">
        <template slot-scope="scope">
            <el-button size="mini" type="danger" v-if="scope.row.pay_status == 'SUCCESS' " @click="edit(scope.row)">编辑</el-button>
      </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>


    <el-dialog title="订单信息" :visible.sync="refundVisible">
      <el-form :model="form">

        <el-form-item label="姓名">
          <el-input type="text"  readonly="" v-model="form.realname" class="binajiinput rbj" ></el-input>
        </el-form-item>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input type="text"  readonly=""  v-model="form.identitycard_no" class="binajiinput rbj"  ></el-input>
        </el-form-item>

        <el-form-item label="联系电话">
          <el-input type="text" v-model="form.tel"  class="binajiinput"  ></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input type="text" v-model="form.address" class="binajiinput"  ></el-input>
        </el-form-item>
        <el-form-item label="预约项目">
          <el-input type="text" readonly="" v-model="form.prescription_name" class="binajiinput rbj" ></el-input>
        </el-form-item>

        <el-form-item label="预约时间">
          <el-input type="text" v-model="form.yysj"  class="binajiinput" ></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="form.beizhu"  class="binajiinput" ></el-input>
        </el-form-item>
        <el-form-item label="订单是否确认" prop="order_status">
          <div class="binajiinput" >

            <el-radio v-model="radio" label=0 >未确认</el-radio>
            <el-radio v-model="radio" label=1>确认</el-radio>

          </div>
       </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
         <el-button @click="refundVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitform">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="预览" :visible.sync="yulan">

      <div style="text-align: center;">
          <img :src="imgUrl" >
      </div>



    </el-dialog>
  </div>
</template>

<script>
import { getZzkdOrder,updateZzkdOrder,getitem } from '../../api/baseset'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false,
      refundVisible: false,
      refund_passwd: '',
      refund_row: [],
      radio: 0,
      payStatus: [
        { key: '请选择', value: 0 },
        { key: '支付成功', value: 'SUCCESS' },
         { key: '未支付', value: 'NOTPAY' },
        { key: '单边账', value: 'SUCCESSBUTHISERROR' },
        { key: '已退费', value: 'REFUND' }
      ],
      payType: [
        { key: '请选择', value: 0 },
        { key: '门诊挂号', value: '门诊挂号' },
        { key: '门诊缴费', value: '门诊缴费' },
        { key: '住院预交金', value: '住院预交金' }
      ],
      itemType:[],
      formInline: {
        page: 1,
        limit: 10
      },
      listData: [], //订单数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      formData:[],
      form: {
        doctorpic: '',
        doctorinfo: ''
      },
      yulan:false,
      orderqr:[
        {key:'未确认',value:'0'},
        {key:'确认',value:'1'},

      ],
      item:[],
      imgUrl:''
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.getxmitem();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
        getZzkdOrder(parameter)
         .then(res => {
           console.log(res)
           this.loading = false
           if (res.success == false) {
             this.$message({
               type: 'info',
               message: res.msg
             })

           } else {
             this.listData = res.data
             // 分页赋值
             this.pageparm.currentPage = this.formInline.page
             this.pageparm.pageSize = this.formInline.limit
             this.pageparm.total = res.count
           }
         })
         .catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
    },
    getxmitem(){
      getitem()
        .then(res => {
            this.item =res.data
        })
        .catch(err => {

        })

    },
    // 重置搜索
    formReset() {
       this.formInline = {
        page: 1,
        limit: 10
      }
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page = 1
      this.formInline.limit = 10
      this.getdata(this.formInline)
    },
    // 编辑
    edit(row) {
      this.refund_row = row;
      this.refundVisible = true;
      this.form = row
      console.log(row.order_status)
      this.radio = row.order_status+ ""
      //this.radio = '1'
      console.log(this.radio)
    },

    autoOrder(row) {
      this.$confirm('确定要同步订单信息吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        this.loading = true
        const param = {id:row.id}
        orderToHis(param)
          .then(res => {
            this.loading = false
            this.$message({
              type: 'info',
              message: res.msg
            })
          })
          .catch(err => {
            this.loading = false
            this.$message.error('同步失败，请稍后再试！')
          })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消同步'
        })
      })
    },
    submitform(){
      var param = this.form;
     param.order_status = this.radio;
     console.log(param);
    // return ;
      updateZzkdOrder(param)
        .then(res => {
          this.loading = false
          this.$message({
            type: 'info',
            message: res.msg
          })
          this.refundVisible = false;
          this.getdata(this.formInline);
        })
        .catch(err => {
          this.loading = false
          this.$message.error('修改失败，请稍后再试！')
        })
    },
    yulandatu(url){
      console.log(url)
      this.imgUrl = url;
      this.yulan = true
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.binajiinput{
  width: 70%;
  float: right;
  margin-right: 10%;
}
.rbj{
  background-color: #666666;
}
.ylt img{
  width: 40px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/zzkd/orderlist.vue